import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { CategoryRating } from '../CategoryRating';
import { CategoryRu, AdditionalRating } from '../../../../models/hotel-reviews';

export interface DetailRatingProps {
    rating: AdditionalRating;
    ratingCount: AdditionalRating;
}

interface StyledDetailRatingProps extends JSSClassesProps<ComponentJSSClasses>, DetailRatingProps {}

export function DetailRating(props: StyledDetailRatingProps) {
    const { classes, rating, ratingCount } = props;

    return (
        <div className={classes.container}>
            <CategoryRating
                rating={rating.Room}
                category={CategoryRu.Room}
                reviewCount={ratingCount.Room}
            />
            <CategoryRating
                rating={rating.Location}
                category={CategoryRu.Location}
                reviewCount={ratingCount.Location}
            />
            <CategoryRating
                rating={rating.Service}
                category={CategoryRu.Service}
                reviewCount={ratingCount.Service}
            />
            <CategoryRating
                rating={rating.PriceQuality}
                category={CategoryRu.PriceQuality}
                reviewCount={ratingCount.PriceQuality}
            />
            <CategoryRating
                rating={rating.Clean}
                category={CategoryRu.Clean}
                reviewCount={ratingCount.Clean}
            />
            <CategoryRating
                rating={rating.Meal}
                category={CategoryRu.Meal}
                reviewCount={ratingCount.Meal}
            />
        </div>
    );
}

export default DetailRating;
